import { z } from 'zod';

export interface TaskCategory {
    id: number;
    name: string;
}

export const taskCategorySchema = z.object({
    id: z.number(),
    name: z.string(),
});

export const mockTaskCategory = ({
    id = 1,
    name = 'Mock Task Category Name',
}: Partial<TaskCategory> = {}): TaskCategory => ({
    id,
    name,
});
